import type { Count, Template, Utils } from "./areas.types";

const compose: Utils["compose"] = (...components) =>
  ([] as Template).concat(...components);

const minCount: Count = 1;

const isMultiCount = (count: Count) =>
  count > minCount && !isNaN(count) && isFinite(count);

const repeat: Utils["repeat"] = (source, count = minCount) =>
  isMultiCount(count)
    ? Array.from(new Array(count)).map(() => source)
    : [source];

const utils: Utils = { compose, repeat };

export default utils;
